<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob" ></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
<!--            <div class="logo_form">-->
<!--&lt;!&ndash;              <img :src="getTranslations.logo_for_branded_projects || 'static/images/Swipo_logo_02.png'" alt="">&ndash;&gt;-->
<!--            </div>-->
            <div class="form_title">
            <h1>{{ getTranslations.visitor_sign_up_2_2steps_left }}</h1>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container" v-if="!hasStepsToDisplay">
              <div class="StandardRegSteps_step step_done">1</div>
              <div class="StandardRegSteps_step">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
            <div class="twoStepRegSteps_Container" v-else>
              <div class="twoStepRegSteps_step step_done">1</div>
              <div class="twoStepRegSteps_step">2</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">
              <img class="form-help__icon"
                   src="static/images/mobile-icon.svg"
                   alt="">
              <p>{{ getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>
            </div>
            <form action="">
              <div class="form-group form-group--icon"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="password"
                       pattern="[0-9]*"
                       inputmode="numeric"
                       class="password form-group__textfield"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_2_validation_code"
                       @keyup="check"
                       v-model="user.pin"/>
                <span v-show="getMessage(message) && user.pin"
                      class="form-group__feedback">{{ getMessage(message) }}
                </span>
              </div>
              <div class="form-footer">
                {{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
              </a>
              </div>
              <div class="col-lg-12">
                <p>{{ getTranslations.visitor_sign_up_complete_registation }}
                <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>
                </p>
              </div>

              <p v-if="displayPrice">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_price') }}</p>

              <input type="submit"
                     :value="getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main' , ( hasErrors || waitForResponse ? 'deactivated' : '')]"
                     id="submitBtn"
                     @click.prevent="checkButton">
              <br/>
              <br/>
              <a href="https://www.google.com" v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit')">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit') }}
              </a>
              <br/>
              <br/>
              <div v-if="hasSimplify()"
                  class="form-footer-text">
                <span  v-for="(key, index) in disclaimers"
                    v-if="getTranslations[key]"
                    :key="index">
                  {{ getTranslations[key] }}
                </span>
              </div>
              <div class="form-footer-text" v-if="showDisclaimer()">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer') }}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <loading v-if="showLoadingModal"
             @close="showLoadingModal = false">
    </loading>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import IntegrationMixin from '@/common/mixins/integration';
import loading from '@/components/home/modals/Loading';

export default {
  name: 'sign-up-2',
  components: { loading },
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      ti: null,
      ts: null,
      message: '',
      hasErrors: false,
      blacklistWords: [],
      waitForResponse: false,
      hasStepsToDisplay: false,
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3', 'visitor_sign_up_disclaimer_text4'],
    };
  },
  created() {
    this.hasStepsToDisplay = this.hasSteps();
    const inputMsisdn = sessionStorage.getItem('msisdn') || this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
    const operator = this.$route.query.operator;
    if (this.integrationHeader === this.availableIntegrations.CROSS_IRAQ.name && this.multiOperatorInfo.operatorPicked === 'KOREK_IRQ') {
      this.ti = this.generateValue();
      this.ts = this.secondsEpoch();
      /* eslint-disable */
      const params = { ti: this.ti, ts: this.ts, te: '#submitBtn', servicename: 'KnowYourCountry', merchantname: 'windowtechnologies', type: 'pin' };
      const paramString = new URLSearchParams(params);
      const url = `https://korek-he.trendy-technologies.com/dcbprotect.php?action=script&${paramString.toString()}`;
      if (sessionStorage.getItem('isRun') === 'true') {
        $.get(url, function (data) {
          console.log(data);
          let scriptToAdd = document.createElement('script');
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'korek_response';
          // Create contents of the script
          let inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode(data.s);
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode("\n}");
          scriptToAdd.appendChild(inlineScript);
          document.head.appendChild(scriptToAdd);
          let tag = document.createElement("script");
          tag.type = 'text/javascript';
          tag.id = 'db_response';
          inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("var event = new Event('DCBProtectRun');\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("document.dispatchEvent(event); \n}");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("sessionStorage.setItem('isRun', 'false');");
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
        });
      }
      if (document.getElementById('korek_response')) {
        document.getElementById('korek_response').remove();
        document.getElementById('db_response').remove();
        sessionStorage.setItem('isRun', 'true');
      }
    }
    if (operator) {
      this.storeOperator(operator);
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((response) => {
        this.updateMultiOperatorOrdinal({ value: response.data.data.multiOperatorOrdinal });
        this.setDisplayPrice({ value: response.data.data.displayPrice });
      });
    }
  },
  methods: {
    ...mapActions('common', [
      'storeOperator',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDisplayPrice',
    ]),
    hasSimplify() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName
        || this.simpleRegistration === this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName;
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer');
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    generateValue() {
      // eslint-disable-next-line
      return 1001 + '-' + Math.floor(Math.random() * Date.now()) + '-' + Math.floor(Math.random() * Date.now());
    },
    secondsEpoch() {
      return Math.floor(Date.now() / 1000);
    },
    checkIfTranslationEmptyByOrdinal(ordinal, key) {
      const indexKey = (ordinal ? `${key}.${ordinal}` : key);
      return !this.getTranslations[indexKey];
    },
    sendNewCode() {
      this.$axios.get(`api/requestPin?msisdn=${encodeURIComponent(this.getRegistrationInfo)}&lang=${this.getLocale}`).then((response) => {
        const res = response.data.responseEnum;
        if (res === 'OPERATION_SUCCESS') {
          this.$router.push('register2');
        } else {
          if (res === 'MSISDN_INVALID') {
            this.message = 'visitor_sign_up_invalid_msisdn_msg';
          } else if (res === 'ALREADY_REGISTERED') {
            this.message = 'visitor_sign_up_msisdn_already_registered';
          } else if (res === 'MSISDN_NOT_EXIST') {
            this.message = 'visitor_sign_up_msisdn_not_exists';
          } else if (res === 'MSISDN_BLACKLISTED') {
            this.message = 'visitor_sign_up_msisdn_blacklisted';
          } else if (res === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (res === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },
    check: function check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.user.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (this.integrationHeader === this.availableIntegrations.CROSS_IRAQ.name) {
        if (document.getElementById('korek_response')) {
          document.getElementById('korek_response').remove();
          document.getElementById('db_response').remove();
        }
      }
      /* eslint-enable */
      if (this.user.pin.length >= 4 && this.user.pin.length <= 8 && !this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;
        const alternateVerifyStep = this.getAlternateVerifyPinAction(this.ti, this.ts);
        if (alternateVerifyStep) {
          alternateVerifyStep.call(this);
        } else {
          this.getNextRegistrationStep()();
        }
      } else {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
      'integrationHeader',
      'availableIntegrations',
      'displayPrice',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp2.vue